import { createFileRoute } from "@tanstack/react-router";
import { loginLoader } from "@/lib/server-fns/auth";

export const Route = createFileRoute("/login")({
  beforeLoad: async () => {
    await loginLoader();
  },
  component: () => null,
});
